export const locale = {
  lang: 'en',
  data: {
    MENU: {
      HOME: 'الرئيسية',
      // EVENTS: 'الفعاليات',
      APPS: {
        SECTION: 'الجداول الأساسية',
        EVENTS: 'الفعاليات',
        ORGANIZERS: 'المشرفين',
        USERS: 'المستخدمين'
      },
      HELPERS: {
        SECTION: 'الجداول المساعدة',
        ORGORDERS: 'طلبات المشرفين',
        EVENTCATEGORIES: 'فئات المناسبات',
        NOTIFICATIONS: 'الإشعارات',
        OFFERS: 'العروض',
        ADMINS: 'المسئولين'
      }
    },
  }
}
